import React, { Component } from 'react'
import DateRange from './dateRange';

const style = {
  checkIn: {
    backgroundColor: '#ef8733',
    color: 'white',
    width: '100px',
    textAlign: 'center',
    padding:'10px 5px 8px',
    fontFamily: 'Ropa Sans'
  },
  Deals: {
    backgroundColor: '#037f03',
    color: 'white',
    width: '100px',
    textAlign: 'center',
    padding:'10px 5px 8px',
    fontFamily: 'Ropa Sans'
  },
  header: {
    display: 'inline-flex'
  },
  dateRange:{
    display: 'inline-flex',
    float:'right',
    padding: '16px 16px 0 0',
    textAlign:"center",
  }

};

class ChartHeader extends Component {
  constructor (){
    super();
    this.state={
      open:false,
      deal:0,
      checkIn:0
    }
  }
  handleOpen=()=>{
    this.setState({open:true})
  }
  handleClose=()=>{
    this.setState({open:false})
  };
  render () {
    const {deal,checkIn}=this.props;

    return (<div>
      <div style={style.header}>
        <div style={style.checkIn}>
          <p className="data-without-space">Check Ins</p>
          <p className="data-without-space-count">{checkIn}</p>
        </div>
        <div style={style.Deals}>
          <p className="data-without-space">Deals Claimed</p>
          <p className="data-without-space-count">{deal}</p>
        </div>
      </div>
      <div style={style.dateRange}>
      <DateRange/>
      </div>
    </div>)
  }
}

export default ChartHeader;